<template>
  <div class="h-100 d-flex flex-column  mx-4 rounded" style="overflow-y:auto;height:100%;">
    <div ref="noteList" class="flex-grow-1 container-fluid p-3 bg-white" style="overflow:auto; width:100%">
      <template v-for="date in Object.keys(notesByDate)">
        <referral-note v-for="note in notesByDate[date]" :key="note.id" :note="note" :referral="item" />

        <div class="text-right" :key="date">
          <small class="text-muted">{{date}}</small>
        </div>
      </template>
      <placeholders ref="addNotePlaceholder" v-if="isAddingNote" :rounded="true">
        <placeholders-text :lines="1" class="fixed" height="2.375rem" />
      </placeholders>
      <a ref="endOfNotes" />
    </div>
    <!-- <div class="add-note-wrapper1 px-4 py-2 bg-light border-top">
      <input v-model="noteText" @keyup.enter="addNote" type="text" class="form-control bg-light border-0" placeholder="Write a comment">
    </div> -->
    <div class="add-note my-2" style="">
      <div class="d-flex ">
        <div class="input-group input-group-lg border-none">
          <input type="text" class="form-control border-0" v-model="noteText" placeholder="Add Note..." @keyup.enter="addNote" />
          <span class="input-group-append">
            <button class="btn btn-outline-primary bg-white border-0" type="button" @click="addNote" :disabled="isAddingNote">
              <font-awesome-icon icon="spinner-third" spin v-if="isAddingNote" />
              <span v-else>
                <font-awesome-icon :icon="['far', 'paper-plane']" />
              </span>
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import ReferralNote from '@/components/referrals/rightbar/ReferralNote.vue'
import { ReferralApi } from '@/services'
export default {
  components: { ReferralNote },
  props: {
    item: {
      type: Object,
      required: false,
    },
  },
  data() {
    return { isAddingNote: false, noteText: null }
  },
  created() {
    this.yesterday = moment().subtract(1, 'days')
  },
  computed: {
    ...mapState('auth', ['user']),
    notesByDate() {
      const byDate = {}
      const custom = this.item.history.filter((s) => s.type == 'CUSTOM')
      for (let i = 0; i < custom.length; i++) {
        const note = custom[i]
        const date = this.displayDate(note)
        if (date in byDate) {
          byDate[date].push(note)
        } else {
          byDate[date] = [note]
        }
      }
      return byDate
    },
  },
  mounted() {
    this.$nextTick(() => {
      // this.$refs.endOfNotes.scrollIntoView({
      //   block: 'end',
      //   behavior: 'smooth',
      // })
      this.$refs.noteList.scroll({
        top: this.$refs.noteList.scrollHeight,
        behavior: 'smooth',
      })
    })
  },
  methods: {
    displayDate(note) {
      const mo = moment(note.created_at)
      return mo.isAfter(this.yesterday) ? mo.fromNow() : mo.format('lll')
    },
    async addNote() {
      const details = this.noteText
      if (!details) return
      this.isAddingNote = true
      this.$nextTick(() => {
        this.$refs.addNotePlaceholder.$el.scrollIntoView({
          block: 'end',
          behavior: 'smooth',
        })
      })
      try {
        this.noteText = ''
        const response = await ReferralApi.saveRelated(
          this.item.id,
          'history',
          { details, referral_id: this.item.id }
        )

        if (!this.item.history.find((r) => r.id == response.id))
          this.item.history.push(response)
      } catch (e) {
        this.$exception(e)
      }
      this.isAddingNote = false
    },
  },
}
</script>

<style>
.add-note-wrapper {
  position: fixed;
  bottom: 0;
  left: 550px;
  width: calc(100% - 550px);
}
</style>